import { Table } from "reactstrap"
import { useMemo } from "react"

const TableLocal = ({
  columns,
  data,
  itemsPerPage = 10,
  currentPage = 1,
  bordered = true,
  responsive = true,
  tableClass = "",
  theadClass = "",
  tbodyClass = "",
  loading = false,
  emptyMessage = "No data available",
  getRowKey,
  rowClassName,
  rowProps,
  children
}) => {
  // Calculate paginated data
  const paginatedData = useMemo(() => {
    if (!data || !Array.isArray(data)) return []
    
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    return data.slice(startIndex, endIndex)
  }, [data, currentPage, itemsPerPage])

  if (loading) {
    return (
      <div className="table-loading">
        {/* Add your loading skeleton here */}
        <div className="placeholder" style={{ height: 200 }}></div>
      </div>
    )
  }

  return (
    <div className="table-local-wrapper">
      <Table bordered={bordered} responsive={responsive} className={tableClass}>
        {columns && (
          <thead className={theadClass}>
            <tr>
              {columns.map((column, index) => (
                <th key={index} {...column.headerProps}>
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
        )}
        
        <tbody className={tbodyClass}>
          {paginatedData.length > 0 ? (
            children ? (
              children(paginatedData)
            ) : (
              paginatedData.map((row, rowIndex) => {
                const key = getRowKey ? getRowKey(row, rowIndex) : rowIndex
                const extraClass =
                  typeof rowClassName === "function"
                    ? rowClassName(row, rowIndex)
                    : rowClassName || ""
                const extraProps =
                  typeof rowProps === "function" ? rowProps(row, rowIndex) : {}
                return (
                  <tr key={key} className={extraClass} {...extraProps}>
                    {columns.map((column, colIndex) => (
                      <td key={colIndex} {...column.cellProps}>
                        {column.cell ? column.cell(row) : row[column.accessor]}
                      </td>
                    ))}
                  </tr>
                )
              })
            )
          ) : (
            <tr>
              <td colSpan={columns?.length || 1} className="text-center">
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  )
}

export default TableLocal